import { DATE_FORMAT_NUMBER_COUNT } from './config';

const parseDayPart = (day: string, month?: string): string => {
  const dayNum = parseInt(day, 10);
  if (dayNum < 1) {
    return '01';
  }

  if (month) {
    const monthNum = parseInt(month, 10);
    if (monthNum >= 1 && monthNum <= 12) {
      const daysInMonth = new Date(2024, monthNum, 0).getDate();
      if (dayNum > daysInMonth) {
        return daysInMonth.toString().padStart(2, '0');
      }
    }
  } else if (dayNum > 31) {
    return '31';
  }

  return day.padStart(2, '0');
};

const parseMonthPart = (month: string): string => {
  const monthNum = parseInt(month, 10);
  if (monthNum > 12) {
    return '12';
  } else if (monthNum < 1) {
    return '01';
  }
  return month.padStart(2, '0');
};

// только для формата DATE_FORMAT (dd/MM/yyyy)
export const formatDateInput = (value: string): string => {
  const numbersOnly = value.replace(/\D/g, '');
  const limitedNumbers = numbersOnly.slice(0, DATE_FORMAT_NUMBER_COUNT);
  if (limitedNumbers.length === 0) {
    return '';
  }

  let day = '';
  let month = '';
  let year = '';

  if (limitedNumbers.length >= 2) {
    day = limitedNumbers.slice(0, 2);
  }

  if (limitedNumbers.length >= 4) {
    month = limitedNumbers.slice(2, 4);
  }

  if (limitedNumbers.length >= 6) {
    year = limitedNumbers.slice(4, 8);
  }

  if (day && month && year) {
    const validatedMonth = parseMonthPart(month);
    const validatedDay = parseDayPart(day, validatedMonth);
    return `${validatedDay}/${validatedMonth}/${year}`;
  }

  if (day && month) {
    const validatedMonth = parseMonthPart(month);
    const validatedDay = parseDayPart(day, validatedMonth);
    if (limitedNumbers.length > 4) {
      return `${validatedDay}/${validatedMonth}/${limitedNumbers.slice(4, 8)}`;
    }
    return `${validatedDay}/${validatedMonth}`;
  }

  if (day) {
    if (limitedNumbers.length > 2) {
      return `${parseDayPart(day)}/${limitedNumbers.slice(2, 4)}`;
    }
    return parseDayPart(day);
  }

  return limitedNumbers;
};
